import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IcsiCmiCertificationComponent } from './member/icsi-cmi-certification.component';
import { IcsiCmiCertificationRoutingModule } from './icsi-cmi-certification-routing.module';

import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../shared/shared.module';
import { IcsiCmiCertificationReportComponent } from './report/icsi-cmi-certification-report/icsi-cmi-certification-report.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { AgGridModule } from 'ag-grid-angular';
import { BaseChartDirective } from 'ng2-charts';


@NgModule({
  declarations: [
    IcsiCmiCertificationComponent,
    IcsiCmiCertificationReportComponent
  ],
  imports: [
    HighchartsChartModule,
    CommonModule,
    BaseChartDirective,
    ReactiveFormsModule,
    FormsModule,
    AgGridModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule.forRoot(),
    SharedModule
  ]
})
export class IcsiCmiCertificationModule { }